import React from 'react';
import Header from '../components/common/Header';
import ProductDetail from '../components/Product/ProductDetail';
import Footer from '../components/common/Footer';

function ProductDetailPage() {
  return (
    <>
      <Header />
      <ProductDetail />
      <Footer />
    </>
  );
}

export default ProductDetailPage;
